import React from "react";

const UserActivityLogs = (PageName, IconName) => {
  const Color = PageName === IconName ? "#4C34AD" : "#fff";

  return (
    <div className="ml-0 flex items-center gap-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="24.718" height="24.718" viewBox="0 0 24.718 24.718">
        <path id="Icon_awesome-history" data-name="Icon awesome-history" d="M25.281,12.9A12.36,12.36,0,0,1,5.165,22.544a1.2,1.2,0,0,1-.092-1.774l.561-.561a1.2,1.2,0,0,1,1.589-.1A9.17,9.17,0,1,0,6.639,6.24L9.168,8.77A.8.8,0,0,1,8.6,10.131H1.36a.8.8,0,0,1-.8-.8V2.089a.8.8,0,0,1,1.361-.564l2.46,2.46a12.359,12.359,0,0,1,20.9,8.913Zm-9.016,3.926.49-.629a1.2,1.2,0,0,0-.21-1.678l-2.028-1.578v-5.2a1.2,1.2,0,0,0-1.2-1.2h-.8a1.2,1.2,0,0,0-1.2,1.2V14.5l3.26,2.535A1.2,1.2,0,0,0,16.265,16.824Z" transform="translate(-0.563 -0.563)" fill="#fff"/>
     </svg>

      <p className="font-bold text-white">Action History</p>
    </div>
  );
};

export default UserActivityLogs;
